import React, { useEffect } from "react";
const episodes = [
  {
    id: "DbKj0Ewuzlr",
    part: "Part 16",
    title: "Where should complexity live?",
  },
  {
    id: "DZmMJ_HAHBj",
    part: "Part 12",
    title: "Design for the habits people already have",
  },
];
export default function UXSeries() {
  useEffect(() => {
    const process = () => window.instgrm?.Embeds?.process();
    let script = document.querySelector('script[data-sls-instagram]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.dataset.slsInstagram = 'true';
      script.addEventListener('load', process);
      document.body.appendChild(script);
    } else {
      script.addEventListener('load', process);
      process();
    }
    return () => script.removeEventListener('load', process);
  }, []);
  return (
    <section
      className="studio-section ux-series"
      aria-labelledby="ux-series-title"
    >
      <div className="ux-series-heading">
        <div>
          <h2 id="ux-series-title">Meet one of our UX experts, Katia</h2>
        </div>
        <p>
          Her Build for Good UX videos explain everyday usability problems on web and mobile. These two are a good place to start.
        </p>
      </div>
      <div className="ux-episodes">
        {episodes.map((ep) => (
          <article key={ep.id}>
            <div className="ux-episode-player">
              <blockquote className="instagram-media" data-instgrm-permalink={`https://www.instagram.com/p/${ep.id}/`} data-instgrm-version="14"><a href={`https://www.instagram.com/p/${ep.id}/`} target="_blank" rel="noopener noreferrer">Watch {ep.title} on Instagram</a></blockquote>
            </div>
            <a
              className="studio-button"
              href={`https://www.instagram.com/p/${ep.id}/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch more on Instagram
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
